/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const redSmsCallbackRequestSchema = z
	.object({
		uuid: z.string().min(1),
		parent_uuid: z.string().min(1).nullish(),
		status: z.string().min(1),
		status_time: z.int(),
		price: z.number().optional(),
		type: z.string().min(1).optional(),
	})
	.describe("Сериализатор обработки коллбэка от RedSMS.");
